export default {
  BusinessStockDeliveryInform: {
    header: {
      queryCode: '单号',
      status: '出库状态',
      outLogicWarehouseCode: '出库逻辑仓',
      outLogicWarehouseCodeText: '请输入逻辑仓编码',
    },

    table: {
      code: '出库通知单号',
      platformOrderCode: '客户订单号',
      orderCode: '内部单号',
      frontRecordCode: '前置单号',
      outTypeMeaning: '出库类型',
      status: '出库状态',
      qty: '需发货数量',
      outLogicWarehouseCode: '出库逻辑仓编码',
      outLogicWarehouseName: '出库逻辑仓名称',
      shopName: '销售店铺',
      channelTypeCodeMeaning: '销售渠道',
    },

    msgError: '请选择待出库单据操作',
    ship: '发 货',
  }
};
